'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { SeoHeadTitleMetas } from '../../seo'

export const OnlineDoctorSeoHeadTags: FC = () => {
  const intl = useIntl()
  const title = intl.formatMessage({
    id: 'onlineDoctorService.meta.title',
  })

  return <SeoHeadTitleMetas title={title} />
}
